import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Bind from 'lodash-decorators/bind';
import Debounce from 'lodash-decorators/debounce';
import { ReactComponent as Arrow } from '../../../../../../common/images/down-arrow.svg';

import styles from './NavList.module.scss';

import { isOnMobile } from 'utils/device-utils.js';

export default class NavList extends Component {
  static propTypes = {
    companies: PropTypes.object.isRequired,
    setActiveSlide: PropTypes.func.isRequired,
    activeSlideIndex: PropTypes.number.isRequired,
    fadeInActive: PropTypes.bool.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      activeSlideIndex: props.activeSlideIndex,
      fadeInActive: props.fadeInActive,
      isMobile: isOnMobile(),
      showMenu: false
    };
    this.companies = props.companies;
  }

  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.state.activeSlideIndex !== props.activeSlideIndex) {
      this.setState({ activeSlideIndex: props.activeSlideIndex });
    }
    if (this.state.fadeInActive !== props.fadeInActive) {
      this.setState({ fadeInActive: props.fadeInActive });
    }
  }

  @Bind()
  @Debounce(100)
  updateDimensions() {
    this.setState({
      isMobile: isOnMobile()
    });
  }

  render() {
    const { isMobile } = this.state;

    if (!isMobile) {
      const navList = this.companies.map((company, index) => {
        const isActive = index === this.state.activeSlideIndex;
        return (
          <span
            key={index}
            className={`${styles.Link} ${isActive ? styles.Active : ''}`}
            onClick={() => this.setActiveSlide(index)}
          >
            {company.name}
          </span>
        );
      });
      return <div className={styles.NavList}>{navList}</div>;
    } else if (!this.state.showMenu) {
      return (
        <span
          key={this.state.activeSlideIndex}
          className={`${styles.Link}  ${styles.Active}`}
          onClick={() => this.showMenu()}
        >
          {this.companies[this.state.activeSlideIndex].name}
          <Arrow className={styles.Arrow} />
        </span>
      );
    } else {
      const navList = this.companies.map((company, index) => {
        const isActive = index === this.state.activeSlideIndex;
        return (
          <span
            key={index}
            className={`${styles.Link}  ${
              isActive ? styles.ActiveDropDown : ''
            }`}
            onClick={() => this.setActiveSlide(index)}
          >
            {company.name}
          </span>
        );
      });
      return <div className={styles.DropDownOpened}>{navList}</div>;
    }
  }

  setActiveSlide(index) {
    if (!this.state.fadeInActive) {
      this.props.setActiveSlide(index);
      this.hideMenu();
    }
  }

  hideMenu() {
    this.setState({
      showMenu: false
    });
  }

  showMenu() {
    this.setState({
      showMenu: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Intro/Components/NavList/NavList.js